import React, { useEffect, useState } from "react";
import { UnoStoreHooks } from "@simulanisindia/ui";
import Permissions from "../../components/RoleManagement/Permissions/Permissions";
import RoleAssigments from "../../components/RoleManagement/ManagePermission/RoleAssigments";
import RoleInformation from "../../components/RoleManagement/RoleInformation/RoleInformation";
import apiClient from "../../apiClient";
import { ALL_PERMISSION_LIST } from "../../apiClient/apiEndpoints";
import { checkPermissionExist } from "../../utils/general";
import { ROLES_EDIT_PERMISSION } from "../../constant/permission";

const { useUnoSelector } = UnoStoreHooks;

const PermissionsTab = ({
  onlyView = false,
  isMobileView=true,
  fetRoleUserLoading,
  getRoleUsers,
  errors,
  roleUserList = [],
  activeTab,
  heading,
  name,
  setName,
  description,
  setDescription,
  UUID = null,
  selectPermissions,
  setSelectPermissions,
  selectedUsers,
}) => {
  const configData = useUnoSelector((state) => state.config);
  const [permissionList, setPermissionList] = useState({});

  const getAllPermission = async () => {
    try {
      let data = await apiClient.get(`${configData.config.UNO_URL}${ALL_PERMISSION_LIST}`);
      setPermissionList(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllPermission();
  }, []);

  const findPermission = (key) => {
    let list = permissionList?.children?.find((e) => e.name.toLowerCase() === key.toLowerCase()) || [];
    return list;
  };

  let checkEditPermission = checkPermissionExist(ROLES_EDIT_PERMISSION);

  const renderContent = () => {
    switch (activeTab) {
      case "#roleinfo":
        return (
          <RoleInformation
            onlyView={!checkEditPermission || onlyView}
            errors={errors}
            heading={heading}
            name={name}
            setName={setName}
            description={description}
            setDescription={setDescription}
        
          />
        );
      case "#role-assignments":
        return (
          <RoleAssigments
            onlyView={!checkEditPermission || onlyView}
            fetRoleUserLoading={fetRoleUserLoading}
            getRoleUsers={getRoleUsers}
            roleUserList={roleUserList}
            name={name}
            roleId="teamTabPermission"
            UUID={UUID}
            selectedUsers={selectedUsers}
          />
        );
      case "#team-management":
        return (
          <Permissions
            onlyView={!checkEditPermission || onlyView}
            heading="Team Management"
            roleId="teamTabPermission"
            description="Team Management"
            permissions={findPermission("TEAM.ALL")}
            selectPermissions={selectPermissions}
            setSelectPermissions={setSelectPermissions}
          />
        );
      case "#resource-management":
        return (
          <Permissions
            onlyView={!checkEditPermission || onlyView}
            heading="Resource Management"
            roleId="teamTabPermission"
            description="Resource Management"
            permissions={findPermission("RESOURCE.ALL")}
            selectPermissions={selectPermissions}
            setSelectPermissions={setSelectPermissions}
          />
        );
      case "#training":
        return (
          <Permissions
            onlyView={!checkEditPermission || onlyView}
            heading="Training"
            roleId="teamTabPermission"
            description="Training"
            permissions={findPermission("TRAINING.ALL")}
            selectPermissions={selectPermissions}
            setSelectPermissions={setSelectPermissions}
            isMobileView={isMobileView}
          />
        );
      case "#guiding":
        return (
          <Permissions
            onlyView={!checkEditPermission || onlyView}
            heading="Guiding"
            roleId="teamTabPermission"
            description="Guiding"
            permissions={findPermission("GUIDING.ALL")}
            selectPermissions={selectPermissions}
            setSelectPermissions={setSelectPermissions}
            isMobileView={isMobileView}
          />
        );
      case "#collaborating":
        return (
          <Permissions
            onlyView={!checkEditPermission || onlyView}
            heading="Collaborating"
            roleId="teamTabPermission"
            description="Collaborating"
            permissions={findPermission("COLLABORATION.ALL")}
            selectPermissions={selectPermissions}
            setSelectPermissions={setSelectPermissions}
            isMobileView={isMobileView}
          />
        );
      case "#authoring":
        return (
          <Permissions
            onlyView={!checkEditPermission || onlyView}
            heading="Authoring"
            roleId="teamTabPermission"
            description="Authoring"
            permissions={findPermission("AUTHORING.ALL")}
            selectPermissions={selectPermissions}
            setSelectPermissions={setSelectPermissions}
            isMobileView={isMobileView}
          />
        );
      case "#content-management":
        return (
          <Permissions
            onlyView={!checkEditPermission || onlyView}
            heading="Content Management"
            roleId="teamTabPermission"
            description="Content Management"
            permissions={findPermission("CONTENT.VIEW")}
            selectPermissions={selectPermissions}
            setSelectPermissions={setSelectPermissions}
            isMobileView={isMobileView}
          />
        );
      case "#general-permissions":
        return (
          <Permissions
            onlyView={!checkEditPermission || onlyView}
            heading="General Permissions"
            roleId="teamTabPermission"
            description="General Management"
            permissions={findPermission("GENERAL.ALL")}
            selectPermissions={selectPermissions}
            setSelectPermissions={setSelectPermissions}
            isMobileView={isMobileView}
          />
        );
      case "#productivity":
        return (
          <Permissions
            onlyView={!checkEditPermission || onlyView}
            heading="Productivity"
            roleId="teamTabPermission"
            description="Productivity"
            permissions={findPermission("PRODUCTIVITY.ALL")}
            selectPermissions={selectPermissions}
            setSelectPermissions={setSelectPermissions}
            isMobileView={isMobileView}
          />
        );
      default:
        <></>;
    }
  };

  return renderContent();
};

export default PermissionsTab;
